import { useState } from "react"
import { SearchWrapper } from "./styled"
import { Link, useNavigate, useLocation } from "react-router-dom"
import { FaSpinner } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { searchActions } from "redux/slice/searchSlice"
import { useEffect } from "react";
import { useDebounce } from "hooks";
import { searchSelector } from "redux/selector"
import Image from "components/Image";
import useParams from "hooks/useParams"

const MIN_PERSON = 0
const MAX_PERSON = 50000000
const SORT = "final_price ASC"
const PAGE = 1
const PER_PAGE = 10
const PERSON = ""
const PROVINCE = "all"

const Search = () => {
    const dispatch = useDispatch()
    const searchState = useSelector(searchSelector)
    const navigate = useNavigate()
    const { setParams } = useParams()
    const location = useLocation()
    const query = new URLSearchParams(location.search)
    const keyWord = query.get("key_word")
    const [searchInput, setSearchInput] = useState(keyWord ?? "")
    const querySearch = useDebounce(searchInput, 300)


    const handleClickSearch = () => {
        navigate(`/search?key_word=${searchInput}`)
    }

    useEffect(() => {
        if (querySearch.trim().length === 0) return
        else {
            const payload = {
                query: querySearch,
                min: MIN_PERSON,
                max: MAX_PERSON,
                sort: SORT,
                page: PAGE,
                perPage: PER_PAGE,
                person: PERSON,
                province: PROVINCE
            }
            dispatch(searchActions.search(payload))
        }
    }, [dispatch, querySearch])

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            handleClickSearch();
        }
    };
    return (
        <SearchWrapper>
            <input
                className="search_input"
                placeholder="Nhập để tìm kiếm tour du lịch của bạn..."
                value={searchInput}
                onChange={(e) => {
                    setSearchInput(e.target.value)
                    setParams({ key_word: e.target.value })
                }}
                onKeyDown={handleKeyDown}
            />
            {
                searchInput !== "" &&
                !searchState.isFetching &&
                <span className="btn_clear_input"
                    onClick={() => setSearchInput("")}

                >
                    <i className="ti-close"
                    ></i>

                </span>
            }
            {
                searchInput !== "" &&
                searchState.isFetching &&
                <span className="btn_clear_input" >
                    <FaSpinner className="loading_search" />
                </span>
            }
            <button className="btn_search" onClick={handleClickSearch}>
                <i className="ti-search"></i>
            </button>
            {
                querySearch.trim() !== "" &&
                <div className="suggestion">
                    <h4 className="title">Kết quả tìm kiếm</h4>
                    {
                        searchState.searchList.length > 0 &&
                        <ul className="search_list">
                            {
                                searchState.searchList.slice(0, 5).map((item, index) => (
                                    <li className="search_item" key={index}>
                                        <Link to={`/tour/${item.slug}`} className="search_link">
                                            <div className="thumbnail">
                                                <Image src={item.thumbnail} />
                                            </div>
                                            <div className="info">
                                                <h1 className="name">{item.name}</h1>
                                                <span className="price">{item.final_price.toLocaleString('vi-VN')} đ</span>
                                            </div>
                                        </Link>
                                    </li>
                                ))
                            }

                        </ul>
                    }
                    {
                        searchState.searchList.length === 0 &&
                        <div className="text-center p-20">
                            <span className="text-red">Không tìm thấy kết quả phù hợp</span>
                        </div>
                    }
                </div>
            }
        </SearchWrapper>
    )
}

export default Search